<template>
  <main class="gc-page">
    <section class="faq-hero">
      <img
        class="faq-hero-img"
        src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/FAQ-banner-Final-scaled-1170x413x0x0x1170x413x1773355114.jpg"
        alt="FAQ Banner"
      >
    </section>

    <section class="gc-section faq-content">
      <div class="gc-container faq-inner">

        <dl class="faq-list">
          <dt class="faq-q"><strong>19.9 是什么？</strong></dt>
          <dd class="faq-a"><strong>19.9</strong> 是一个本地连接平台，帮助人们直接寻找并向本地他人提供服务。没有中间人或佣金。所以，无论您需要拼车司机、宠物美容师、家教、餐饮承办人、杂工、创意专业人士还是其他日常服务，<strong>19.9</strong> 都能让您更轻松地与社区中的人建立联系。</dd>

          <dt class="faq-q"><strong>19.9 是移动 App 还是网站？</strong></dt>
          <dd class="faq-a">两者都是。移动 App 现在可以下载，桌面版随后推出。</dd>

          <dt class="faq-q"><strong>费用是多少？</strong></dt>
          <dd class="faq-a">免费加入。订阅一个类别每月只需 ￥19.90，即可在该类别中发布不限数量的信息。</dd>

          <dt class="faq-q"><strong>谁可以使用 圣淘沙信息科技？</strong></dt>
          <dd class="faq-a"><strong>19.9</strong> 为连接的两端而建——需要服务的人与提供服务的人。服务提供者可以推广他们的服务并与本地客户建立联系。需求方可以搜索所需的帮助、比较选项并直接联系。</dd>

          <dt class="faq-q"><strong>作为服务提供者，我如何获得报酬？</strong></dt>
          <dd class="faq-a">您与对方直接协商付款方式。<strong>19.9</strong> 不处理、持有或管理付款。</dd>

          <dt class="faq-q"><strong>19.9 是否抽取佣金？</strong></dt>
          <dd class="faq-a">不。<strong>19.9</strong> 旨在帮助人们直接连接。我们不从您的收入中抽成。</dd>

          <dt class="faq-q"><strong>如何在平台上联系某人？</strong></dt>
          <dd class="faq-a">一旦找到符合您需求的信息或服务提供者，您可以直接通过平台建立联系，并继续对话。</dd>

          <dt class="faq-q"><strong>在 19.9 上可以找到哪些类型的服务？</strong></dt>
          <dd class="faq-a"><strong>19.9</strong> 设计支持广泛的本地服务。包括拼车和交通帮助、宠物照护、家教辅导、活动支持、食品相关服务、家居服务、个人协助、创意工作等。</dd>

          <dt class="faq-q"><strong>19.9 只面向服务提供者吗？</strong></dt>
          <dd class="faq-a">不。<strong>19.9</strong> 同时面向服务提供者和寻找帮助的人。您可以用来提供服务、请求服务，或两者兼有。</dd>

          <dt class="faq-q"><strong>我可以提供多项服务吗？</strong></dt>
          <dd class="faq-a">可以。您可以根据需要订阅任意数量的服务类别，并创建信息来推广您提供的多项服务。</dd>

          <dt class="faq-q"><strong>发布后可以编辑或删除吗？</strong></dt>
          <dd class="faq-a">可以。您可以通过账户管理自己的信息，并按需要更新或删除。</dd>

          <dt class="faq-q"><strong>19.9 在我的地区可用吗？</strong></dt>
          <dd class="faq-a"><strong>19.9</strong> 旨在支持本地社区并持续扩展。随着平台的发展，可用性可能有所不同。</dd>

          <dt class="faq-q"><strong>作为服务提供者发布需要特殊资质吗？</strong></dt>
          <dd class="faq-a">这取决于您提供的服务类型。某些服务可能需要根据当地或州法律持有执照、认证、保险或其他资质。服务提供者有责任遵守其工作可能适用的任何要求。</dd>

          <dt class="faq-q"><strong>19.9 是否验证服务提供者？</strong></dt>
          <dd class="faq-a"><strong>19.9</strong> 是一个连接平台。用户在聘请或与他人合作前，尤其是涉及专业或受监管的服务时，应自行进行必要的核实。</dd>

          <dt class="faq-q"><strong>可以用于副业或兼职吗？</strong></dt>
          <dd class="faq-a">可以。<strong>19.9</strong> 非常适合发展副收入的人、自由职业者、小型本地企业以及持续提供专业服务的人。</dd>

          <dt class="faq-q"><strong>企业也可以使用 19.9 吗？</strong></dt>
          <dd class="faq-a">可以。独立提供者、自由职业者和本地企业都可以使用 <strong>19.9</strong> 推广服务并与客户建立联系。</dd>

          <dt class="faq-q"><strong>如果我在使用平台时需要帮助怎么办？</strong></dt>
          <dd class="faq-a">访问我们的帮助中心，或通过 App 直接联系我们的支持团队。</dd>

          <dt class="faq-q"><strong>如果与另一位用户发生问题怎么办？</strong></dt>
          <dd class="faq-a">我们鼓励用户清晰、专业地沟通。如果遇到平台相关问题，您可以通过 App 或网站联系支持团队。</dd>

          <dt class="faq-q"><strong>19.9 是否处理退款或争议？</strong></dt>
          <dd class="faq-a">不。因为 <strong>19.9</strong> 不处理付款，也不作为交易的一方，退款、取消和争议必须由相关人员直接解决。</dd>

          <dt class="faq-q"><strong>我的信息是隐私安全的吗？</strong></dt>
          <dd class="faq-a"><strong>19.9</strong> 非常重视用户隐私。关于信息的收集、使用和保护方式，请查阅我们的隐私政策。</dd>

          <dt class="faq-q"><strong>如何开始使用？</strong></dt>
          <dd class="faq-a">创建您的账户，完善个人资料，发布或浏览服务，然后开始与您所在地区的人们建立联系。</dd>
        </dl>

      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'FaqView'
}
</script>

<style scoped>
.faq-hero {
  width: 100%;
}

.faq-hero-img {
  width: 100%;
  display: block;
}

.faq-content {
  background: #fff;
}

.faq-inner {
  max-width: 860px;
}

.faq-list {
  text-align: left;
}

.faq-q {
  font-size: 20px;
  color: #1f2933;
  margin: 48px 0 14px;
  line-height: 1.4;
}

.faq-q:first-child {
  margin-top: 0;
}

.faq-q strong {
  font-weight: 900;
  color: #1f2933;
}

.faq-a {
  font-size: 17px;
  line-height: 1.75;
  color: #4a5568;
  margin: 0 0 8px;
}

.faq-a strong {
  font-weight: 800;
  color: #1f2933;
}

@media (max-width: 780px) {
  .faq-q {
    font-size: 18px;
    margin: 36px 0 10px;
  }

  .faq-a {
    font-size: 15px;
  }
}
</style>
